import * as React from "react";
import { Fragment, Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import "./App.css";
import Header from "./components/layout/header/Header";
import Footer from "./components/layout/footer/Footer";
// import HomePage from './components/pages/home/HomePage';
// import PredictionsMonitor from './components/pages/predictions-monitor/PredictionsMonitor';
// import TournamentRankings from './components/pages/tournament-rankings/TournamentRankings';
import HeadToHeadRankings from "./components/pages/tournament-rankings/HeadToHeadRankings";
import WorkInProgress from "./components/pages/special/WorkInProgress";
import Divider from "react-md/lib/Dividers/Divider";
import TournamentRankings from "./components/pages/tournament-rankings/TournamentRankings";

class App extends Component {
  render() {
    return (
      <Router>
        <Fragment>
          <Header />
          <main>
            <Route exact={true} path="/" component={WorkInProgress} />
            <Route path="/rpl/schedule" component={WorkInProgress} />
            <Route path="/rpl/rankings" component={HeadToHeadRankings} />
            <Route path="/cl/rankings" component={TournamentRankings} />
            <Route path="/cl/predictions" component={WorkInProgress} />
          </main>
          <Divider />
          <Footer/>
        </Fragment>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx